import { render, staticRenderFns } from "./ApprovesList.vue?vue&type=template&id=28526c14&scoped=true&"
import script from "./ApprovesList.vue?vue&type=script&lang=js&"
export * from "./ApprovesList.vue?vue&type=script&lang=js&"
import style0 from "./ApprovesList.vue?vue&type=style&index=0&id=28526c14&lang=scss&scoped=true&"
import style1 from "./ApprovesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28526c14",
  null
  
)

export default component.exports